import React from 'react';
import AlertDialog from './AlertDialog';
import useAlertDialog from '../../../redux/features/alertDialog/useAlertDialog';

export const CommonAlertDialog = () => {
  const { isOpen, texts, settings, onAcceptAlertDialog, onCloseAlertDialog } = useAlertDialog();

  return (
    <AlertDialog
      isOpen={isOpen}
      title={texts.title}
      message={texts.message}
      confirmButtonMessage={texts.confirmButton}
      handleConfirmButton={onAcceptAlertDialog}
      showCancelButton={settings.showCancelButton}
      cancelButtonMessage={texts.cancelButton}
      handleCancelButton={onCloseAlertDialog}
      showCloseButton={settings.showCloseButton}
      handleCloseButton={onCloseAlertDialog}
    />
  );
};
